import { ISSHero } from 'types/interfaces/sulu/ISnippets';

import currentLanguage from './currentLanguage';

export default async (): Promise<ISSHero> => {
  const response = await fetch(`/${currentLanguage}/api/snippet-areas/hero`);
  if (response.ok) {
    const jsonResponse = await response.json();
    return jsonResponse;
  }
  /**
   * ts-ignore is necessary here because an empty object
   * is not valid for the ISSHero interface
   * */
  // @ts-ignore
  return {};
};
